export interface BoundingPoint {
    x: number;
    y: number;
}
